import { render, staticRenderFns } from "./ServicePartnerDetail.vue?vue&type=template&id=57d0cde9"
import script from "./ServicePartnerDetail.vue?vue&type=script&lang=ts"
export * from "./ServicePartnerDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports